export const DDEX_DEFAULT_PAGE_SIZE = 10;
